import type { CollectionFilterLabels, ProductFilterLabels } from "../../types/types";

export interface FilterChipProps {
  label: CollectionFilterLabels | ProductFilterLabels;
  active: boolean;
  onClick: () => void;
}

export default function FilterChip({ label, active, onClick }: FilterChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      style={{
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: "16px",
        padding: "2px 10px",
        borderRadius: "9999px",
        border: "none",
        cursor: "pointer",
        backgroundColor: active ? "var(--color-dark-dust)" : "var(--color-good-ochre-bg)",
        color: active ? "var(--color-white)" : "var(--color-rodeo-black)",
        transition: "background-color 0.15s, color 0.15s",
        outline: "none",
        whiteSpace: "nowrap",
      }}
      onFocus={(e) => {
        e.currentTarget.style.boxShadow = "0 0 0 2px var(--color-dark-dust)";
      }}
      onBlur={(e) => {
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {label}
    </button>
  );
}
